import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";

import appReducer, { IAppState } from "./appSlice";
import sousModuleReducer, { ISousModuleState } from "../components/GestionFonctionnalite/SousModule/sousModuleSlice";
import groupeFonctionnaliteReducer, { IGroupeFonctionnaliteState } from "../components/GestionFonctionnalite/GroupeFonctionnalite/groupeFonctionnaliteSlice";
import fonctionnaliteReducer, { IFonctionnaliteState } from "../components/GestionFonctionnalite/Fonctionnalite/fonctionnaliteSlice";
import moduleReducer, { IModuleState } from "../components/GestionFonctionnalite/Module/moduleSlice";
import niveauAccesReducer, { INiveauAccesState } from "../components/GestionNiveauAccès/niveauAccesSlice";
import modeleRapportReducer, { IModeleRapportState } from "./modeleRapportSlice";
import persisteReducer, { IPersistState } from "./persisteSlice";
import siteWebReducer, { ISiteWebState } from "./siteWebSlice";
import focusEcoleReducer, { IFocusEcoleState } from "./focusEcoleSlice";
import userReducer, { IUserState } from "./userSlice";
import moduleDroitReducer, { IModuleDroitState } from "../GestionUtilisateur/AppGestionInterne/CreationDroit/Module/moduleDroitSlice";
import SousModuleDroitReducer, { ISousModuleDroitState } from "../GestionUtilisateur/AppGestionInterne/CreationDroit/SousModuleDroit/sousModuleDroitSlice";
import droitReducer, { IDroitState } from "../GestionUtilisateur/AppGestionInterne/CreationDroit/Droit/droitSlice";
import utilisateurAppGestionInterneReducer, { IUtilisateurAppGestionInterneState } from "../GestionUtilisateur/AppGestionInterne/Utilisateur/utilisateurAppGestionInterneSlice";
import xserverstateReducer, { Ixserverstate } from "./xserverSlice";
import messagerieReducer, { IMessagerieState } from "./messagerieSlice";
import partenaireReducer, { IPartenaireState } from "./partenaireSlice";

export interface IReduxState {
  application: IAppState;
  sousModule: ISousModuleState;
  groupeFonctionnalite: IGroupeFonctionnaliteState;
  fonctionnalite: IFonctionnaliteState;
  module: IModuleState;
  niveauAcces: INiveauAccesState;
  modeleRapport: IModeleRapportState;
  persiste: IPersistState;
  siteWeb: ISiteWebState;
  focusEcole: IFocusEcoleState;
  users: IUserState;
  modulesDroit: IModuleDroitState;
  sousModuleDroit: ISousModuleDroitState;
  droits: IDroitState;
  utilisateurAppGestionInterne: IUtilisateurAppGestionInterneState;
  xserverstates: Ixserverstate;
  messagerie: IMessagerieState;
  partenaires: IPartenaireState;
}

const reducers = combineReducers({
  application: appReducer,
  sousModule: sousModuleReducer,
  groupeFonctionnalite: groupeFonctionnaliteReducer,
  fonctionnalite: fonctionnaliteReducer,
  module: moduleReducer,
  niveauAcces: niveauAccesReducer,
  modeleRapport: modeleRapportReducer,
  persiste: persisteReducer,
  siteWeb: siteWebReducer,
  focusEcole: focusEcoleReducer,
  users: userReducer,
  modulesDroit: moduleDroitReducer,
  sousModuleDroit: SousModuleDroitReducer,
  droits: droitReducer,
  utilisateurAppGestionInterne: utilisateurAppGestionInterneReducer,
  xserverstates: xserverstateReducer,
  messagerie: messagerieReducer,
  partenaires: partenaireReducer
});

const persistConfig = {
  key: "root",
  storage: storage,
  whitelist: ["persiste", "application", "users", "focusEcole"], // liste des slices qui doivent etre persister
};

const persistedReducer = persistReducer(persistConfig, reducers);

const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware: [thunk],
});

export default store;

